<template>
  <div>
    <div class="test-list d-print-none">
      <v-app-bar color="success">
        <v-btn dark text @click="exit()">
          <v-icon>mdi-exit-to-app</v-icon>Изход
        </v-btn>
        <download-csv
          class="v-btn v-btn--flat v-btn--text theme--dark v-size--default"
          :data="csvTests"
          delimiter=";"
          name="PCR-tests.csv"
          :fields="csvFields"
        >
          <v-icon dark>mdi-file-excel</v-icon>Експортиране
        </download-csv>
        <v-btn dark text href="https://newpcr.d2zedl9v20jn2a.amplifyapp.com/#/test-list">
          <v-icon>mdi-archive</v-icon>Архив
        </v-btn>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog">
          <template v-slot:activator="{ on, attrs }">
            <v-btn dark text class="mb-2" v-bind="attrs" v-on="on">
              <v-icon>mdi-plus</v-icon>Нов Тест
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-form v-model="valid">
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="1" sm="1" md="1">
                      <v-select
                        v-model="editedItem.testType"
                        :items="testTypes"
                        hint="Тип"
                        label="Тип"
                        :rules="typeRules"
                        required
                        :persistent-hint="true"
                      />
                    </v-col>
                    <v-col cols="3" sm="3" md="3">
                      <v-text-field
                        :rules="nameRules"
                        required
                        v-model="editedItem.firstName"
                      >
                        <template #label>
                          Име
                          <span class="red--text">
                            <strong>*</strong>
                          </span>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2" md="2">
                      <v-text-field
                        v-model="editedItem.middleName"
                        label="Презиме"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="3" sm="3" md="3">
                      <v-text-field
                        :rules="nameRules"
                        required
                        v-model="editedItem.lastName"
                      >
                        <template #label>
                          Фамилия
                          <span class="red--text">
                            <strong>*</strong>
                          </span>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="1" sm="1" md="1">
                      <v-text-field
                        required
                        :rules="ageRules"
                        type="number"
                        v-model="editedItem.age"
                        label="Възраст"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="1" sm="1" md="1">
                      <v-text-field
                        type="number"
                        v-model="editedItem.personalId"
                        label="ЕГН"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="2">
                      <v-text-field
                        v-model="editedItem.phoneNumber"
                        label="Телефон"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="2">
                      <v-select
                        v-model="editedItem.sex"
                        :items="sex"
                        :persistent-hint="true"
                        hint="Пол"
                        label="Пол"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="4" md="2">
                      <v-select
                        v-model="editedItem.payment"
                        :items="paymentTypes"
                        :persistent-hint="true"
                        hint="Плащане"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="3" md="2">
                      <v-checkbox
                        v-model="editedItem.complaints"
                        label="Оплаквания"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="3" md="2">
                      <v-checkbox
                        v-model="editedItem.contacted"
                        label="Контактен"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="3" md="2">
                      <v-checkbox
                        v-model="editedItem.previousTests"
                        label="Предишни тестове"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-menu
                        ref="testDatePicker"
                        v-model="testDatePicker"
                        :close-on-content-click="false"
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :value="computedTestDate"
                            label="Дата на пробонабиране"
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :allowed-dates="allowedTestDates"
                          v-model="testDate"
                          no-title
                          @input="setTestDate()"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-menu
                        ref="resultDatePicker"
                        v-model="resultDatePicker"
                        :close-on-content-click="false"
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :value="computedResultDate"
                            label="Дата на резултат"
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :allowed-dates="allowedResultDates"
                          v-model="resultDate"
                          no-title
                          @input="setResultDate()"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-select
                        v-model="editedItem.testResult"
                        :items="testResults"
                        hint="Резултат"
                        label="Резултат"
                        color="primary"
                        :persistent-hint="true"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="12">
                      <v-textarea
                        v-model="editedItem.comment"
                        clearable
                        label="Забележка"
                        outlined
                        rows="1"
                        row-height="15"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="3" sm="3" md="3">
                      <v-text-field
                        hint="Код"
                        label="Код"
                        v-model="editedItem.code"
                        :persistent-hint="true"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Отказ</v-btn>
                <v-btn
                  id="saveButton"
                  :disabled="!valid"
                  color="blue darken-1"
                  text
                  @click="save"
                  >Запази</v-btn
                >
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </v-app-bar>
      <template>
        <v-expansion-panels focusable>
          <v-expansion-panel>
            <v-expansion-panel-header>
              Филтриране
              <i>{{ applyedFilters }}</i>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="d-flex justify-center">
                <v-card class="mt-2 px-5">
                  <v-card-title>Различни</v-card-title>
                  <v-checkbox
                    v-for="(option, index) in [true, false]"
                    :key="index"
                    v-model="filterCheckedOut"
                    :label="option ? 'Проверени' : 'Не Проверени'"
                    :value="option"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="filterCode"
                    label="С Код"
                    :value="true"/>
                </v-card>
                <v-card class="mt-2 px-5">
                  <v-card-title>По Номер</v-card-title>
                  <v-text-field
                    :clearable="true"
                    v-model="filterStartIndexNumber"
                    :value="filterStartIndexNumber"
                    label="От Номер"
                    @click:clear="
                      clearFilterInputField('filterStartIndexNumber')
                    "
                  ></v-text-field>
                  <v-text-field
                    :clearable="true"
                    v-model="filterEndIndexNumber"
                    :value="filterEndIndexNumber"
                    label="До Номер"
                    @click:clear="clearFilterInputField('filterEndIndexNumber')"
                  ></v-text-field>
                </v-card>
                <v-card class="mt-2 px-5">
                  <v-card-title>По Резултат</v-card-title>
                  <v-checkbox
                    v-for="(result, index) in possibleResults"
                    :key="index"
                    v-model="filterResult"
                    :label="possibleResultsLabels[index]"
                    :value="result"
                  ></v-checkbox>
                </v-card>
                <v-card id="payment-filter" class="mt-2 px-5 d-flex flex-wrap">
                  <v-card-title id="payment-filter-title"
                    >По Плащане</v-card-title
                  >
                  <v-checkbox
                    class="payment-item"
                    v-for="(payment, index) in possiblePayments"
                    :key="index"
                    v-model="filterPayment"
                    :label="possiblePaymentsLabels[index]"
                    :value="payment"
                  ></v-checkbox>
                </v-card>
                <v-card id="type-filter" class="mt-2 px-5">
                  <v-card-title id="type-filter-title">По Тип</v-card-title>
                  <v-checkbox
                    class="type-item"
                    v-for="(type, index) in possibleTestTypes"
                    :key="index"
                    v-model="filterType"
                    :label="testTypesLabels[index]"
                    :value="type"
                  ></v-checkbox>
                </v-card>
                <v-card class="mt-2 px-5">
                  <v-card-title>По Дaта на Пробонабиране</v-card-title>
                  <v-menu
                    ref="filterTestStartDateDatePicker"
                    v-model="filterTestStartDateDatePicker"
                    :close-on-content-click="false"
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :clearable="true"
                        :value="filterTestStartDate"
                        label="От Дата"
                        v-bind="attrs"
                        v-on="on"
                        @click:clear="
                          clearFilterInputField('filterTestStartDate')
                        "
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filterTestStartDateValue"
                      @input="setFilterTestStartDate()"
                      no-title
                    ></v-date-picker>
                  </v-menu>
                  <v-menu
                    ref="filterTestEndDateDatePicker"
                    v-model="filterTestEndDateDatePicker"
                    :close-on-content-click="false"
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :clearable="true"
                        :value="filterTestEndDate"
                        label="До Дата"
                        v-bind="attrs"
                        v-on="on"
                        @click:clear="
                          clearFilterInputField('filterTestEndDate')
                        "
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filterTestEndDateValue"
                      @input="setFilterTestEndDate()"
                      no-title
                    ></v-date-picker>
                  </v-menu>
                </v-card>
                <v-card class="mt-2 px-5">
                  <v-card-title>По Дaта на Резултат</v-card-title>
                  <v-menu
                    ref="filterResultStartDateDatePicker"
                    v-model="filterResultStartDateDatePicker"
                    :close-on-content-click="false"
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :clearable="true"
                        :value="filterResultStartDate"
                        label="От Дата"
                        v-bind="attrs"
                        v-on="on"
                        @click:clear="
                          clearFilterInputField('filterResultStartDate')
                        "
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filterResultStartDateValue"
                      @input="setFilterResultStartDate()"
                      no-title
                    ></v-date-picker>
                  </v-menu>
                  <v-menu
                    ref="filterResultEndDateDatePicker"
                    v-model="filterResultEndDateDatePicker"
                    :close-on-content-click="false"
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :clearable="true"
                        :value="filterResultEndDate"
                        label="До Дата"
                        v-bind="attrs"
                        v-on="on"
                        @click:clear="
                          clearFilterInputField('filterResultEndDate')
                        "
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filterResultEndDateValue"
                      @input="setFilterResultEndDate()"
                      no-title
                    ></v-date-picker>
                  </v-menu>
                </v-card>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-toolbar flat color="white" class="d-flex justify-end">
          <v-text-field
            :clearable="true"
            v-model="search"
            label="Търсене"
            class="mx-4 mt-4"
          ></v-text-field>
        </v-toolbar>
        <v-data-table
          :value="selectedItems"
          show-select
          :disable-sort="true"
          loading="true"
          :headers="headers"
          :items="tests"
          class="elevation-1"
          :search="search"
          :footer-props="{ itemsPerPageOptions: [10, 20, 40, 100, -1] }"
          @current-items="getFiltered"
          @item-selected="verifyItem"
          @toggle-select-all="verifyMultiple"
        >
          <template v-slot:header.data-table-select></template>
          <template v-slot:item.code="{ item }">
              <v-icon v-if="item.code && item.code.length">mdi-star</v-icon>
          </template>
          <template v-slot:item.testType="{ item }">
            <span>{{ item.testType | testTypeFilter(testTypes) }}</span>
          </template>
          <template v-slot:item.testDate="{ item }">
            <span>{{ item.testDate | moment }}</span>
          </template>
          <template v-slot:item.resultDate="{ item }">
            <span>{{ item.resultDate | moment }}</span>
          </template>
          <template v-slot:item.sex="{ item }">
            <span>{{ item.sex | sex(sex) }}</span>
          </template>
          <template v-slot:item.payment="{ item }">
            <span>{{ item.payment | payment(paymentTypes) }}</span>
          </template>
          <template v-slot:item.complaints="{ item }">
            <v-icon style="display: flex" v-if="item.complaints"
              >mdi-check</v-icon
            >
          </template>
          <template v-slot:item.contacted="{ item }">
            <v-icon style="display: flex" v-if="item.contacted"
              >mdi-check</v-icon
            >
          </template>
          <template v-slot:item.comment="{ item }">
            <v-icon style="display: flex" v-if="item.comment">mdi-check</v-icon>
          </template>
          <template v-slot:item.published="{ item }">
            <v-icon style="display: flex" v-if="item.published"
              >mdi-check</v-icon
            >
          </template>
          <!-- <template v-slot:item.previousTests="{ item }">
            <v-icon style="display: flex" v-if="item.previousTests"
              >mdi-check</v-icon
            >
          </template> -->
          <template v-slot:item.testResult="{ item }">
            <v-chip
              :color="getResultColor(item.testResult)"
              :dark="item.testResult !== possibleResults[3]"
              >{{ item.testResult | testResult(testResults) }}</v-chip
            >
          </template>
          <template v-slot:top></template>
          <template v-slot:item.actions="{ item }">
            <v-icon dense class="mr-2" @click="editItem(item)"
              >mdi-pencil</v-icon
            >
            <v-icon dense class="mr-2" @click="deleteItem(item)"
              >mdi-delete</v-icon
            >
            <v-icon dense class="mr-2" @click="printItem(item)"
              >mdi-printer</v-icon
            >
          </template>
        </v-data-table>
      </template>
    </div>
    <div class="d-print-block printable">
      <img class="logo" src="./../assets/mbal_logo.png" />
      <span class="title"
        >„МНОГОПРОФИЛНА БОЛНИЦА ЗА АКТИВНО ЛЕЧЕНИЕ – БЛАГОЕВГРАД„ АД</span
      >
      <span class="title-2"
        >гр. Благоевград, ул. „Славянска” № 60, тел. 073/82-92-329, факс: 073/
        88-41-29</span
      >
      <span class="fish">
        <h2>{{`ФИШ ЗА ВИРУСОЛОГИЧНО ИЗСЛЕДВАНЕ (${itemForPrint.testType === 'Pcr' ? 'PCR' : 'АНТИГЕНЕН ТЕСТ'})`}}</h2>
      </span>
      <span class="patient patient-name">
        <span>
          <b
            >{{ itemForPrint.firstName }} {{ itemForPrint.middleName }}
            {{ itemForPrint.lastName }}</b
          >
        </span>
      </span>
      <span class="patient patient-info">
        <span>
          ЕГН:
          <b>{{ itemForPrint.personalId }}</b>
        </span>
        <span>
          Възраст:
          <b>{{ itemForPrint.age }}</b>
        </span>
        <span>
          Пол:
          <b>{{ itemForPrint.sex | printableSex }}</b>
        </span>
        <span>
          Телефон:
          <b>{{ itemForPrint.phoneNumber }}</b>
        </span>
      </span>
      <span class="patient">
        <span
          >Личен лекар:
          _________________________________________________________________________________________</span
        >
      </span>
      <span class="patient">
        <span>Амб./ИЗ № _____________ Дата ____/____/202___</span>
      </span>
      <span class="patient">
        <span>
          Материал за изследване:
          <b>назо-фарингеален секрет</b>
        </span>
      </span>
      <span class="patient">
        <span>
          Да бъде извършено изследване за:
          <b>SARS-CoV-2 RNA (COVID-19)</b>
        </span>
      </span>
      <span class="patient">Резултати и дата на предишно изследване:</span>
      <span class="patient"
        >Дата ____/____/202___ Резултат:
        _______________________________________________________________________</span
      >
      <span class="patient"
        >Дата ____/____/202___ Резултат:
        _______________________________________________________________________</span
      >
      <span class="patient doctor send">
        <span>Изпращащ лекар:__________________________________</span>
        <span>Гр.__________________________________</span>
      </span>
      <hr class="patient" />
      <span class="patient">
        <span>
          Дата на постъпване на материала в лабораторията:
          <b>{{ itemForPrint.testDate | moment }}</b>
        </span>
      </span>
      <span class="patient">
        <span>Годност на материала: ☐ Годен ☐ Негоден</span>
      </span>
      <span class="patient">
        <span>
          Лабораторен номер:
          <b>{{ itemForPrint.indexNumber }}</b>
        </span>
      </span>
      <span class="patient">
        <span>
          <b>РЕЗУЛТАТ НА ПРОВЕДЕНОТО ИЗСЛЕДВАНЕ</b>
        </span>
      </span>
      <span class="patient result">
        <span>
          <b>SARS-CoV-2 RNA (COVID-19):</b>
          <b>{{ itemForPrint.testResult | printableResult }}</b>
        </span>
      </span>
      <span class="patient">
        <span>
          Дата на излизане на резултата:
          <b>{{ itemForPrint.resultDate | moment }}</b>
        </span>
      </span>
      <span class="patient doctor">
        <span>Извършил изследването:</span>
      </span>
      <span class="patient doctor signature">Подпис и личен печат</span>
    </div>
  </div>
</template>
<script>
import { Auth, Hub, DataStore, Predicates, SortDirection } from "aws-amplify";
import { QuickPcr } from "./../models";
import moment from "moment";
// import oldtests from '../../oldtests';

const defaultItem = {
  indexNumber: "",
  testType: "",
  firstName: "",
  middleName: "",
  lastName: "",
  personalId: "",
  age: null,
  complaints: false,
  contacted: false,
  payment: "Payed",
  previousTests: false,
  testResult: "InProgres",
  testDate: moment().format("x"),
  resultDate: moment().format("x"),
  sex: null,
  comment: "",
  published: false,
  phoneNumber: "",
  code: "",
};

const possibleResults = ["Positive", "Negative", "Doubtful", "InProgres"];

const possibleTestTypes = ["QuickTest", "Pcr"];

const testTypesLabels = ["Бърз", "PCR"];

const possibleResultsLabels = [
  "Положителен",
  "Отрицателен",
  "Съмнителен",
  "Обработва се",
];

const possiblePayments = [
  "Payed",
  "RZI",
  "MBAL",
  "Razlog",
  "TUB",
  "AUB",
  "PIRIN",
  "NotPayed",
];

const possiblePaymentsLabels = [
  "Платено",
  "РЗИ",
  "МБАЛ",
  "Разлог",
  "ТУБ",
  "АУБ",
  "ПИРИН",
  "Не е платено",
];

export default {
  name: "Test-List",

  data() {
    return {
      itemForPrint: { ...defaultItem },
      index: 0,
      valid: false,
      nameRules: [(v) => !!v || "Задължително поле"],
      ageRules: [
        (v) => !!v || "Задължително поле",
        (v) => v >= 0 || "Възраст не може да бъде по-малка от 0 години",
      ],
      typeRules:[(v) => !!v || "Задължително поле"],
      filterStartIndexNumber: "",
      possibleTestTypes,
      testTypesLabels,
      filterEndIndexNumber: "",
      filteredItems: [],
      possiblePayments,
      possiblePaymentsLabels,
      possibleResults,
      possibleResultsLabels,
      filterResult: [],
      filterType: [],
      filterCheckedOut: [],
      filterCode: [],
      filterPayment: [],
      filterTestStartDate: "",
      filterTestStartDateValue: "",
      filterTestEndDate: "",
      filterTestEndDateValue: "",
      filterResultStartDate: "",
      filterResultStartDateValue: "",
      filterResultEndDate: "",
      filterResultEndDateValue: "",
      search: "",
      nextIndexNumber: "",
      subscription: undefined,
      testDatePicker: false,
      resultDatePicker: false,
      filterResultStartDateDatePicker: false,
      filterResultEndDateDatePicker: false,
      filterTestStartDateDatePicker: false,
      filterTestEndDateDatePicker: false,
      testDate: "",
      resultDate: "",
      tests: [],
      dialog: false,
      printDialog: false,
      lastEditedIndex: -1,
      csvFields: [
        "Код_на_лаборатория",
        "Тип_на_идентификатор",
        "Идентификатор",
        "Име",
        "Презиме",
        "Фамилия",
        "Възраст",
        "Пол",
        "Вид_изследване",
        "Лабораторен_резултат",
        "Дата_на_пробонабиране",
        "Анатомично_място_на_пробата",
        "Клинични_симптоми",
        "Дата_на_излизане_на_резултата",
        "Получател_на_пробата",
        "УИН_на_изпращащ_лекар",
        "Заплаща_се_от_НЗОК",
        "УИН_на_извършващ_дейността_лекар",
        "Номер",
        "Забележка",
        "Предишни_тестове",
        "Телефон",
        "Код",
      ],
      paymentTypes: [
        { value: possiblePayments[0], text: possiblePaymentsLabels[0] },
        { value: possiblePayments[1], text: possiblePaymentsLabels[1] },
        { value: possiblePayments[2], text: possiblePaymentsLabels[2] },
        { value: possiblePayments[3], text: possiblePaymentsLabels[3] },
        { value: possiblePayments[4], text: possiblePaymentsLabels[4] },
        { value: possiblePayments[5], text: possiblePaymentsLabels[5] },
        { value: possiblePayments[6], text: possiblePaymentsLabels[6] },
        { value: possiblePayments[7], text: possiblePaymentsLabels[7] },
      ],
      sex: [
        { value: "Male", text: "Male" },
        { value: "Female", text: "Female" },
      ],
      testResults: [
        { value: possibleResults[0], text: possibleResultsLabels[0] },
        { value: possibleResults[1], text: possibleResultsLabels[1] },
        { value: possibleResults[2], text: possibleResultsLabels[2] },
        { value: possibleResults[3], text: possibleResultsLabels[3] },
      ],
      testTypes: [
        { value: possibleTestTypes[0], text: testTypesLabels[0] },
        { value: possibleTestTypes[1], text: testTypesLabels[1] },
      ],
      editedIndex: -1,
      defaultItem,
      editedItem: {
        ...defaultItem,
      },
    };
  },

  async created() {
    Hub.listen("datastore", async (hubData) => {
      const { event } = hubData.payload;
      if (event === "ready") {
        this.tests = await DataStore.query(QuickPcr, Predicates.ALL, {
          sort: (s) => s.indexNumber(SortDirection.DESCENDING),
        });
        this.subscription = DataStore.observe(QuickPcr).subscribe(() => {
          this.loadTests();
        });
      }
    });
    await DataStore.clear();
    await DataStore.start();
  },

  computed: {
    selectedItems() {
      return this.tests.filter((item) => item.checkedOut);
    },
    applyedFilters() {
      const filterType = this.filterType.length ? "По Тип" : "";
      const filterResult = this.filterResult.length ? "По Резултат" : "";
      const filterPayment = this.filterPayment.length ? "По Плащане" : "";
      const filterCheckedOut = this.filterCheckedOut.length
        ? "По Проверени"
        : "";
      const filterCode = this.filterCode.length ? "По Код" : "";
      const isFilterByDateApplyed =
        this.filterTestStartDate ||
        this.filterTestEndDate ||
        this.filterResultStartDate ||
        this.filterResultEndDate;
      const filterDate = isFilterByDateApplyed ? "По Дата" : "";
      const filterIndexNumber =
        this.filterStartIndexNumber || this.filterEndIndexNumber
          ? "По Номер"
          : "";
      const colon =
        filterIndexNumber ||
        filterResult ||
        filterPayment ||
        filterDate ||
        filterCheckedOut ||
        filterCode ||
        filterType
          ? ":"
          : "";

      return `${colon}  ${filterIndexNumber} ${filterResult} ${filterPayment} ${filterDate} ${filterCheckedOut} ${filterType} ${filterCode}`;
    },
    headers() {
      return [
        {
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: "",
          value: "code",
          filter: (value) =>
            !this.filterCode.length
              ? true
              : value && value.length,
        },
        {
          text: "№",
          value: "indexNumber",
          filter: (value) => {
            if (!this.filterEndIndexNumber && !this.filterStartIndexNumber) {
              return true;
            }
            return !this.filterEndIndexNumber
              ? value == this.filterStartIndexNumber
              : Number(value) >= Number(this.filterStartIndexNumber) &&
                  Number(value) <= Number(this.filterEndIndexNumber);
          },
        },
        {
          text: "Тип",
          value: "testType",
          filter: (value) =>
            !this.filterType.length
              ? true
              : this.filterType.some((result) => result === value),
        },
        {
          text: "hiddenSearchableIndexNumber",
          value: "indexNumber",
          align: " d-none",
        },
        {
          text: "hiddenCheckedOut",
          value: "checkedOut",
          align: " d-none",
          filter: (value) =>
            !this.filterCheckedOut.length
              ? true
              : this.filterCheckedOut.some((option) => option === !!value),
        },
        { text: "Име", value: "firstName" },
        { text: "Презиме", value: "middleName" },
        { text: "Фамилия", value: "lastName" },
        { text: "ЕГН", value: "personalId" },
        { text: "Възраст", value: "age" },
        { text: "Телефон", value: "phoneNumber" },
        { text: "Оплаквания", value: "complaints" },
        { text: "Контактен", value: "contacted" },
        {
          text: "Плащане",
          value: "payment",
          filter: (value) =>
            !this.filterPayment.length
              ? true
              : this.filterPayment.some((payment) => payment === value),
        },
        {
          text: "Резултат",
          value: "testResult",
          filter: (value) =>
            !this.filterResult.length
              ? true
              : this.filterResult.some((result) => result === value),
        },
        {
          text: "Дата на пробонабиране",
          value: "testDate",
          filter: (value) => {
            if (!this.filterTestEndDateValue && !this.filterTestStartDateValue)
              return true;
            if (this.filterTestStartDateValue && !this.filterTestEndDateValue) {
              return moment(Number(value)).isSame(
                moment(this.filterTestStartDateValue).format("YYYY-MM-DD"),
                "day"
              );
            }
            if (this.filterTestEndDateValue && !this.filterTestStartDateValue) {
              return moment(Number(value)).isSame(
                moment(this.filterTestEndDateValue).format("YYYY-MM-DD"),
                "day"
              );
            }
            return (
              moment(Number(value)).isSameOrBefore(
                moment(this.filterTestEndDateValue).format("YYYY-MM-DD"),
                "day"
              ) &&
              moment(Number(value)).isSameOrAfter(
                moment(this.filterTestStartDateValue).format("YYYY-MM-DD"),
                "day"
              )
            );
          },
        },
        {
          text: "Дата на резултат",
          value: "resultDate",
          filter: (value) => {
            if (
              !this.filterResultEndDateValue &&
              !this.filterResultStartDateValue
            )
              return true;
            if (
              this.filterResultStartDateValue &&
              !this.filterResultEndDateValue
            ) {
              return moment(Number(value)).isSame(
                moment(this.filterResultStartDateValue).format("YYYY-MM-DD"),
                "day"
              );
            }
            if (
              this.filterResultEndDateValue &&
              !this.filterResultStartDateValue
            ) {
              return moment(Number(value)).isSame(
                moment(this.filterResultEndDateValue).format("YYYY-MM-DD"),
                "day"
              );
            }
            return (
              moment(Number(value)).isSameOrBefore(
                moment(this.filterResultEndDateValue).format("YYYY-MM-DD"),
                "day"
              ) &&
              moment(Number(value)).isSameOrAfter(
                moment(this.filterResultStartDateValue).format("YYYY-MM-DD"),
                "day"
              )
            );
          },
        },
        { text: "Пол", value: "sex" },
        { text: "Забележка", value: "comment" },
        { text: "Издаден", value: "published" },
        { text: "", value: "actions", sortable: false },
      ];
    },

    csvTests() {
      const result = this.filteredItems.map((item) => {
        const {
          indexNumber: Номер,
          firstName: Име,
          middleName: Презиме,
          lastName: Фамилия,
          personalId: Идентификатор,
          age: Възраст,
          previousTests: Предишни_тестове,
          testResult: Лабораторен_резултат,
          resultDate: Дата_на_излизане_на_резултата,
          testDate: Дата_на_пробонабиране,
          sex: Пол,
          comment: Забележка,
          phoneNumber: Телефон,
          payment: Заплаща_се_от_НЗОК,
          testType: Вид_изследване,
          code: Код,
        } = item;
        return {
          Код_на_лаборатория: "0103211001",
          Тип_на_идентификатор: "ЕГН",
          Идентификатор,
          Име,
          Презиме,
          Фамилия,
          Възраст,
          Пол: Пол === "Male" ? "M" : "F",
          Вид_изследване: Вид_изследване === "Pcr" ? "10-RT PCR" : "30-бърз тест за антигени",
          Лабораторен_резултат: this.testResults.find(
            (testResult) => testResult.value === Лабораторен_резултат
          ).text,
          Дата_на_пробонабиране: Дата_на_пробонабиране
            ? moment(Number(Дата_на_пробонабиране)).format("DD.MM.YYYY")
            : "",
          Анатомично_място_на_пробата: "Назофарингеален/орофарингеален секрет",
          Клинични_симптоми: "",
          Дата_на_излизане_на_резултата: Дата_на_излизане_на_резултата
            ? moment(Number(Дата_на_излизане_на_резултата)).format("DD.MM.YYYY")
            : "",
          Получател_на_пробата: "пациент",
          УИН_на_изпращащ_лекар: "",
          Заплаща_се_от_НЗОК: Заплаща_се_от_НЗОК === "RZI" ? "да" : "не",
          УИН_на_извършващ_дейността_лекар: "",
          Номер,
          Забележка,
          Предишни_тестове: Предишни_тестове ? "Има" : "",
          Телефон,
          Код,
        };
      });
      return result;
    },

    formTitle() {
      return this.editedIndex === -1 ? "Нов Тест" : "Редактиране";
    },

    computedTestDate() {
      const testDate = this.editedItem.testDate;
      return testDate
        ? moment(Number(testDate)).format("DD/MM/YYYY")
        : moment().format("DD/MM/YYYY");
    },

    computedResultDate() {
      const resultDate = this.editedItem.resultDate;
      return resultDate
        ? moment(Number(resultDate)).format("DD/MM/YYYY")
        : moment().format("DD/MM/YYYY");
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    clearFilterInputField(inputField) {
      this[inputField] = "";
      if (this[inputField + "Value"]) {
        this[inputField + "Value"] = "";
      }
    },

    getResultColor(itemResult) {
      switch (itemResult) {
        case "Positive":
          return "red";
        case "Negative":
          return "green";
        case "Doubtful":
          return "orange";
        default:
          return "";
      }
    },
    getFiltered(currentItems) {
      this.filteredItems = currentItems;
    },

    async verifyItem({ item, value }) {
      await this.updateTest({ ...item, checkedOut: value });
    },

    verifyMultiple({ items, value }) {
      items.forEach(
        async (item) => await this.updateTest({ ...item, checkedOut: value })
      );
    },

    exit() {
      Auth.signOut().then(() => this.$router.push("/"));
    },

    async printItem(item) {
      this.itemForPrint = { ...item };
      if (!item.published) {
        await this.updateTest({ ...item, published: true });
      } else {
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }
      window.print();
    },

    async createNewTest(test) {
      await DataStore.save(
        new QuickPcr({
          ...test,
          indexNumber: this.getNextIndexNumber(),
        })
      );
    },

    async deleteTest(testID) {
      await DataStore.delete(QuickPcr, testID);
    },

    async loadTests() {
      this.tests = await DataStore.query(QuickPcr, Predicates.ALL, {
        sort: (s) => s.indexNumber(SortDirection.DESCENDING),
      });
    },

    getNextIndexNumber() {
      return Number(this.tests[0].indexNumber) + 1;
    },

    allowedResultDates(val) {
      const formatedTestDate = moment(Number(this.editedItem.testDate)).format(
        "YYYY-MM-DD"
      );
      return moment(val).isSameOrAfter(formatedTestDate);
    },

    allowedTestDates(val) {
      return moment(val).isSameOrAfter(moment().format("YYYY-MM-DD"));
    },
    editItem(item) {
      this.editedIndex = this.tests.indexOf(item);
      this.lastEditedIndex = this.editedIndex;
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      this.testDate = "";
      this.resultDate = "";
    },

    async deleteItem(item) {
      confirm(`Сигурни ли сте че искате да изтриете избрания тест?`) &&
        this.deleteTest(item.id);
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      if (this.editedIndex > -1) {
        await this.updateTest(this.editedItem);
      } else {
        await this.createNewTest(this.editedItem);
      }
      this.close();
    },

    async updateTest(test) {
      const originalTest = await DataStore.query(QuickPcr, test.id);

      await DataStore.save(
        QuickPcr.copyOf(originalTest, (updatedTest) => {
          updatedTest.firstName = test.firstName;
          updatedTest.lastName = test.lastName;
          updatedTest.middleName = test.middleName;
          updatedTest.indexNumber = Number(test.indexNumber);
          updatedTest.personalId = test.personalId;
          updatedTest.age = test.age;
          updatedTest.complaints = test.complaints;
          updatedTest.contacted = test.contacted;
          updatedTest.payment = test.payment;
          updatedTest.previousTests = test.previousTests;
          updatedTest.testResult = test.testResult;
          updatedTest.testDate = test.testDate;
          updatedTest.testType = test.testType;
          updatedTest.resultDate = test.resultDate;
          updatedTest.sex = test.sex;
          updatedTest.phoneNumber = test.phoneNumber;
          updatedTest.comment = test.comment;
          updatedTest.checkedOut = test.checkedOut;
          updatedTest.code = test.code;
          updatedTest.published = test.published || false;
        })
      );
    },

    setTestDate() {
      this.editedItem.testDate = moment(this.testDate).format("x");
      this.testDatePicker = false;
      this.testDate = "";
    },
    setResultDate() {
      this.editedItem.resultDate = moment(this.resultDate).format("x");
      this.resultDatePicker = false;
      this.resultDate = "";
    },
    setFilterResultStartDate() {
      this.filterResultStartDate = moment(
        this.filterResultStartDateValue
      ).format("DD/MM/YYYY");
      this.filterResultStartDateDatePicker = false;
    },
    setFilterTestStartDate() {
      this.filterTestStartDate = moment(this.filterTestStartDateValue).format(
        "DD/MM/YYYY"
      );
      this.filterTestStartDateDatePicker = false;
    },
    setFilterResultEndDate() {
      this.filterResultEndDate = moment(this.filterResultEndDateValue).format(
        "DD/MM/YYYY"
      );
      this.filterResultEndDateDatePicker = false;
    },
    setFilterTestEndDate() {
      this.filterTestEndDate = moment(this.filterTestEndDateValue).format(
        "DD/MM/YYYY"
      );
      this.filterTestEndDateDatePicker = false;
    },
  },
  destroyed() {
    if (!this.subscription) return;
    this.subscription.unsubscribe();
  },

  filters: {
    moment: function (date) {
      return date ? moment(Number(date)).format("DD/MM/YYYY") : "";
    },

    sex: function (sex) {
      return sex === "Male" ? "M" : "F";
    },

    printableSex: function (sex) {
      return sex === "Male" ? "Мъж" : "Жена";
    },

    testResult: (result, testResults) =>
      testResults.find((testResult) => testResult.value === result).text,

    testTypeFilter: (result, possibleTestTypes) =>
      possibleTestTypes.find((testType) => testType.value === result).text,

    printableResult: (result) => {
      const possibleResults = {
        Positive: "Установява се",
        Negative: "Не се установява",
        Doubtful: "Съмнителен",
      };
      return possibleResults[result];
    },

    payment: (payment, paymentTypes) =>
      paymentTypes.find((paymentType) => paymentType.value === payment).text,
  },
};
</script>
<style>
.payment-item {
  width: 50%;
}

#payment-filter-title {
  width: 20rem;
  justify-content: center;
}

#payment-filter {
  width: 20rem;
}
.row {
  align-items: flex-end;
}

.printable {
  padding: 2rem;
  display: none;
}

.patient {
  font-size: 16px;
  width: 100%;
  display: flex;
  margin-top: 1rem;
}

.patient-info {
  justify-content: space-between;
}
.patient-name {
  font-size: 20px;
  justify-content: space-evenly;
}
.result {
  border: 2px solid;
  padding: 1rem;
  justify-content: center;
}

.doctor {
  justify-content: center;
}
.signature {
  text-align: end;
  display: flex;
  flex-direction: column;
  font-size: 10px;
}

.send {
  text-align: end;
  display: flex;
  flex-direction: column;
}

.title,
.title-2 {
  float: left;
  width: 40rem;
  text-align: center;
}

.logo {
  width: 80px;
  float: left;
}

.fish {
  margin: 40px auto;
  float: left;
  text-decoration: underline;
}
@media print {
  @page {
    size: auto;
    margin: 0;
  }
}
</style>